import React from 'react';

import './breadcrumb.scss';
import { Link } from 'react-router-dom';
import Icon from '../icon';

const BreadcrumbNav = props => {
  const { crumbTrail } = props;

  return (
    <div className="breadcrumb-nav">
      {crumbTrail.map(({ href, label }, idx) => {
        const isLast = idx === crumbTrail.length - 1;
        return (
          <span className="crumb-container" key={label}>
            {href ? (
              <span className="crumb">
                <Link to={href}>{label}</Link>
              </span>
            ) : (
              <span className="crumb">{label}</span>
            )}
            {!isLast && (
              <span className="arrow">
                <Icon size={16} iconName="chevronRight" />
              </span>
            )}
          </span>
        );
      })}
    </div>
  );
};

export default BreadcrumbNav;
